module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "video-nav"
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("../assets/imgs/close.svg")
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  })]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-room-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "player"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c3f4ddd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Video.vue
// module id = 197
// module chunks = 1